import styles from '../InternalExternalDetail.module.css'
import Button from './Button'

const DocItem = ({ title, checked, actions = [], url, onToggle }) => {
  const handlePreview = (e) => {
    e.preventDefault()
    if (!url) return
    const win = window.open('', '_blank')
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const pdfBlob = new Blob([blob], { type: 'application/pdf' })
        const objectUrl = URL.createObjectURL(pdfBlob)
        if (win) {
          win.location.href = objectUrl
        }
      })
  }

  const handleDownload = (e) => {
    e.preventDefault()
    if (!url) return
    fetch(url)
      .then((res) => res.blob())
      .then((blob) => {
        const objectUrl = URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = objectUrl
        a.download = title || 'document'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        URL.revokeObjectURL(objectUrl)
      })
  }

  return (
    <label className={styles.docCard}>
      <div className={styles.docLeft}>
        <input type="checkbox" checked={checked} onChange={onToggle} />
        <span className={styles.docTitle}>{title}</span>
      </div>

      {actions.length > 0 && (
        <div className={styles.docActions}>
          {actions.includes('preview') && (
            <Button variant="docIconBtn" icon="preview" onClick={handlePreview} />
          )}
          {actions.includes('download') && (
            <Button variant="docIconBtn" icon="download" onClick={handleDownload} />
          )}
        </div>
      )}
    </label>
  )
}

export default DocItem
